var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5556 16H13.3333V17.8H11.5556V16ZM24 10.6V23.2C24 24.199 23.2089 25 22.2222 25H9.77778C8.79111 25 8 24.19 8 23.2V10.6C8 9.61 8.8 8.8 9.77778 8.8H10.6667V7H12.4444V8.8H19.5556V7H21.3333V8.8H22.2222C23.2089 8.8 24 9.61 24 10.6ZM9.77778 12.4H22.2222V10.6H9.77778V12.4ZM22.2222 23.2V14.2H9.77778V23.2H22.2222ZM18.6667 17.8V16H20.4444V17.8H18.6667ZM15.1111 17.8V16H16.8889V17.8H15.1111ZM11.5556 19.6H13.3333V21.4H11.5556V19.6ZM18.6667 21.4V19.6H20.4444V21.4H18.6667ZM15.1111 21.4V19.6H16.8889V21.4H15.1111Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b715af3b2342b8087f39ed0da4869dbe.svg";
export { ForwardRef as ReactComponent };